var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkingPlace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M295.749,156.351l-51.639,-0l27.697,-46.945c6.103,-1.408 11.267,-7.041 11.267,-13.613c-0,-6.573 -4.225,-11.737 -10.328,-13.614l-14.553,-43.658l-6.572,4.225l-0.939,1.408l13.145,38.964c-4.695,2.347 -7.981,7.041 -7.981,12.675c0,5.163 2.817,9.388 7.042,11.736l-28.636,48.822l-229.558,-0c-2.347,-0 -4.694,1.877 -4.694,4.694l-0,25.819c-0,2.817 1.878,4.695 4.694,4.695l47.884,-0l-22.534,102.808c-0.469,3.286 1.878,5.633 4.695,5.633l20.186,-0c2.347,-0 4.225,-1.408 4.694,-3.756l23.003,-104.685l136.138,-0l27.697,104.685c0.47,1.878 2.348,3.287 4.695,3.287l20.186,-0c3.755,-0 5.633,-3.756 4.225,-6.573l-26.758,-101.869l46.944,0c2.816,0 4.694,-1.877 4.694,-4.694l0,-25.819c0,-1.878 -1.878,-4.225 -4.694,-4.225Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.371,57.768l4.695,7.511c1.878,2.816 6.103,2.816 7.98,0.469l18.309,-24.88l-17.839,-29.106l-30.514,6.103c-3.286,0.939 -4.694,4.225 -2.817,7.042l4.695,7.98c-7.042,6.103 -7.981,13.614 -3.756,20.186c4.225,7.042 11.736,8.45 19.247,4.695Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.785,27.723c6.572,-4.225 8.45,-13.144 4.694,-19.716c-0.469,-0.47 -7.98,-13.145 -20.186,-5.634l-8.919,5.634l15.492,25.35l8.919,-5.634Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingPlace);
export default __webpack_public_path__ + "static/media/working_place.7cad6061.svg";
export { ForwardRef as ReactComponent };